const COUNTRY_RE = /^(usa|us|u\.s\.a?\.?|united states|canada)$/i;
const STATE_ZIP_RE = /^([A-Za-z]{2})[\s,]+([A-Za-z0-9][A-Za-z0-9\s-]{2,10})$/;
const STATE_RE = /^[A-Za-z]{2}$/;
const ZIP_RE = /^(\d{5}(-\d{4})?|[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)$/;

/**
 * Older customer records keep the whole address in one string
 * ("1000 Rue Sainte-Catherine O, Montreal, QC H3B 4W5"). When the structured
 * city/state/zip fields are blank, split the legacy string so autofill
 * populates every address field instead of dumping it all into Street.
 */
export function splitLegacyAddress(customer = {}) {
  const out = {
    street: customer.address || "",
    city: customer.city || "",
    state: customer.state || "",
    zip: customer.zip_code || "",
  };
  if ((out.city && out.state) || !out.street.includes(",")) return out;

  const parts = out.street.split(",").map((p) => p.trim()).filter(Boolean);
  if (parts.length < 2) return out;

  let idx = parts.length;
  if (COUNTRY_RE.test(parts[idx - 1])) idx--;

  let tail = parts[idx - 1] || "";
  const sz = tail.match(STATE_ZIP_RE);
  if (sz) {
    out.state = out.state || sz[1].toUpperCase();
    out.zip = out.zip || sz[2].trim();
    idx--;
  } else if (ZIP_RE.test(tail)) {
    out.zip = out.zip || tail;
    idx--;
    if (idx >= 1 && STATE_RE.test(parts[idx - 1])) {
      out.state = out.state || parts[idx - 1].toUpperCase();
      idx--;
    }
  } else if (STATE_RE.test(tail)) {
    out.state = out.state || tail.toUpperCase();
    idx--;
  }
  if (idx - 1 >= 1) {
    out.city = out.city || parts[idx - 1];
    idx--;
  }
  out.street = parts.slice(0, Math.max(idx, 1)).join(", ");
  return out;
}
